import _ from 'lodash';
import { Observable } from 'rxjs';

import { ArchiveResource } from '@skinsoft/types';
import { SEARCH_TYPES } from '@skinsoft/const';
import { ArchiveOfflineDataFetcher, ArchiveOfflineDataUpdateCacher } from '@skinsoft/offline';
import { EntityDataStore } from '@skinsoft/entity-data-store';

declare const config
const ARCHIVE_SEARCH_TYPES: string[] = config.archive_search_types

// @ts-ignore
export class ArchiveDataStore extends EntityDataStore<ArchiveResource, any, ArchiveResource> {
    public static getInstance() {
        if (!ArchiveDataStore.instance) {
            ArchiveDataStore.instance = new ArchiveDataStore();
        }

        return ArchiveDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$archiveDataStore = ArchiveDataStore.getInstance();
    }

    private static instance: ArchiveDataStore = null as any

    constructor() {
        super('archives', [SEARCH_TYPES.archive])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ArchiveOfflineDataFetcher()
    }

    protected initializeDataPusher() {
        this.offlineDataUpdateCacher = new ArchiveOfflineDataUpdateCacher()
    }

    public createWithDescriptionLevel(descriptionLevelId: string): Observable<ArchiveResource> {
        const endpoint = `${this.endpoint}?type=${descriptionLevelId}`
        return super.create(undefined, undefined, endpoint)
    }

    public createWithDescriptionLevelOffline(descriptionLevelId: string): Observable<ArchiveResource> {
        const currentInstitution: string = localStorage.getItem('institution') as string

        const createBody: Partial<ArchiveResource> = {
            institutionCreation: currentInstitution,
        }

        _.set(
            createBody,
            "identificationArchiveSchema.descriptionLevel",
            descriptionLevelId
        )

        return this.createOffline(createBody)
    }
}